import { createContext, useContext, useEffect } from 'react';

export type RegionalOverviewNavigationState = 'home' | 'nested';

export interface RegionalOverviewNavigation {
  onHomeBack?: () => void;
  reportRenderedState?: (state: RegionalOverviewNavigationState) => void;
}

export const RegionalOverviewReadyContext = createContext<((isReady: boolean) => void) | undefined>(undefined);

export const useRegionalOverviewReady = (isReady: boolean, enabled = true): void => {
  const reportReady = useContext(RegionalOverviewReadyContext);

  useEffect(() => {
    if (!enabled) return;
    reportReady?.(isReady);
    return () => reportReady?.(false);
  }, [enabled, isReady, reportReady]);
};
